import {useCallback} from 'react';
import type {Lock} from 'services/locks/types';
import {useLocalization} from 'localization';
import {usePostLockMutation} from 'services/locks';
import {useSnacks} from 'components/snacks';

type PostLock = () => Promise<Lock | undefined>;

/**
 * Posts lock for work and returns lock object or undefined if failed.
 */
export const usePostLockWithErrorHandling = (workId: string): PostLock => {
  const {t} = useLocalization();

  const [postLock] = usePostLockMutation();
  const {warningSnack} = useSnacks();

  return useCallback((): Promise<Lock | undefined> => {
    return postLock({contextId: workId, contextType: 'work'})
      .unwrap()
      .then(lock => {
        return lock;
      })
      .catch(() => {
        // If lock fails, still allow editing with warning
        warningSnack(t('page.metadata.lock.message.lockFailed'));
        return undefined;
      });
  }, [postLock, t, warningSnack, workId]);
};
